<template lang="pug">
	div
		loading(:active.sync="busy", :is-full-page="false")
		.card.card-custom.gutter-b
			.card-header
				.card-title
					.card-label Assets
				.card-toolbar
			.card-body
				form.form.form-inline.form-filters(@submit.prevent="loadData()", :class="{expanded:filtersExpanded}")
					a.btn.btn-primary.toggle-filters.d-md-none(v-b-toggle.form-filters)
						span Filters
						i.fa.fw.fa-chevron-up.transition-all(:class="{'rotate-180':filtersExpanded}")
					b-collapse#form-filters.dont-collapse-sm(style="width: 100%;", v-model="filtersExpanded")
						.row.filters-form-row
							.form-row-main.col-auto.mr-auto(style="flex:1;")
								.form-group
									label Search
									input.form-control.input-search(type="text", placeholder="Search...", v-model="filters.keyword", v-debounce:300ms="loadData")
								.form-group.no-label
									button.btn.btn-primary(type="submit") Go
							.form-row-end.col-auto
								.form-group.no-label
									router-link.btn.btn-success(:to="{name:'asset-add'}")
										i.flaticon2-plus
										| Add
						.row.filters-form-row
							.form-row-main.col-auto.mr-auto(style="flex:1;")
								.form-group
									label Add app by URL
									input.form-control(type="text", v-model="storeUrl")
								.form-group.no-label
									button.btn.btn-secondary(type="button", @click="addAppByURL()") Add

				p.clearfix &nbsp;

				table.table.table-bordered
					thead
						tr
							th ID
							th(style="width:68px") &nbsp;
							th(style="width:68px") &nbsp;
							th Name
							th Actions
					tbody
						tr(v-if="records.length===0")
							td(colspan="7") No matching records were found
						tr(v-for="r in records", :key="r.id")
							td {{ r.id }}
							td.text-center
								div.app-icon-container
									img(v-if="r.icon", :src="r.icon")
							td.text-center(style="vertical-align: middle;")
								div.store-icon
									i.la.la-android(v-if="r.platform==='android'")
									i.la.la-apple(v-if="r.platform==='ios'")
							td {{ r.name }}
							td.actions
								router-link.btn.btn-action.btn-secondary(:to="{name:'asset-edit', params: {id:r.id}}")
									i.la.la-pen
								.btn.btn-action.btn-outline-danger()
									i.la.la-trash

				paginate(:paginator="paginate", @update-page-size="loadData")

</template>
<style lang="scss">

.store-icon {
	i {
		font-size: 40px;
	}
}
</style>
<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
export default {
	name: 'AssetList',
	data(){
		return {
			busy: false,
			storeUrl: '',
			paginate: {
				numPages: 0,
				total: 0,
				page: 1,
				limit: 50,
				onPageChange: () => {
					this.loadData();
				}
			},
			filters: {
				keyword: '',
			},
			records: [],
			filtersExpanded: false,
		};
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ title: 'Assets' }
		]);
	},
	methods: {

		async addAppByURL(r){
			let data = {
				url: this.storeUrl
			};
			try {
				await this.$api.post('/assets/addAppByURL', data);
				this.storeUrl = '';
				this.loadData();
			} catch (e){
				console.error(e);
			}
		},

		async loadData(){
			this.busy = true;
			let params = {
				page: this.paginate.page,
				limit: this.paginate.limit,
				keyword: this.filters.keyword,
			};
			try {
				let resp = await this.$api.get('/assets/getList', {params});
				this.records = resp.records;
				this.paginate.total = resp.total;
				this.paginate.numPages = Math.max(Math.ceil(this.paginate.total / this.paginate.limit), 1);
			} catch (e){
				console.error(e);
			}
			this.busy = false;
		}
	},
	created(){
		this.loadData();
	}

}
</script>
